import { createContext, useCallback, useEffect, useState } from 'react'

import { MusicAudio } from '@/config/AudioConfig'
import { reportError } from '@/instrumentation'
import AudioEngine, { getAudioPath } from '@/webgl/audio/AudioEngine'

const AudioEngineContext = createContext<AudioEngine>(null)

type AudioContextProviderProps = {
  children: React.ReactNode
}

let initialized = false

export const AudioEngineProvider = ({ children }: AudioContextProviderProps) => {
  const [abortController] = useState(new AbortController())

  const loadMusic = useCallback(() => {
    if (initialized) return

    const bundle = AudioEngine.createBundle()
    bundle.addSprite(getAudioPath('music/music.json'))

    AudioEngine.instance.music.setBundle(bundle)
    const layers = AudioEngine.instance.music.createLayer(MusicAudio.Runner)
    layers.addTrack(MusicAudio.Runner_A, 1)
    layers.addTrack(MusicAudio.Runner_B, 0)

    bundle.load(abortController.signal).catch((e) => reportError(e, { feature: 'audio-bundle', bundle: 'music' }))
  }, [abortController])

  const loadUI = useCallback(() => {
    if (initialized) return
    const bundle = AudioEngine.createBundle()
    bundle.addSprite(getAudioPath('ui_audio/ui.json'))
    bundle.load(abortController.signal).catch((e) => reportError(e, { feature: 'audio-bundle', bundle: 'ui' }))
  }, [abortController])

  useEffect(() => {
    loadUI()
    loadMusic()
    initialized = true

    return () => {
      AudioEngine?.setMute(true)
    }
  }, [loadMusic, loadUI])

  return <AudioEngineContext.Provider value={AudioEngine.instance}>{children}</AudioEngineContext.Provider>
}
